var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactNofill = function SvgContactNofill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    fill: "none",
    viewBox: "0 0 28 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.969 19.094H11.03A10.86 10.86 0 0 0 .146 29.979c0 1.113.866 1.98 1.979 1.98h23.75c1.051 0 1.98-.867 1.98-1.98 0-6-4.887-10.885-10.886-10.885M3.115 28.99c.494-3.897 3.834-6.927 7.916-6.927h5.938c4.02 0 7.36 3.03 7.855 6.927zM14 16.125c4.33 0 7.917-3.525 7.917-7.917 0-4.33-3.588-7.916-7.917-7.916-4.391 0-7.917 3.587-7.917 7.916A7.89 7.89 0 0 0 14 16.125M14 3.26a4.96 4.96 0 0 1 4.948 4.948A4.923 4.923 0 0 1 14 13.156c-2.783 0-4.948-2.165-4.948-4.948A4.923 4.923 0 0 1 14 3.26"
  })));
};
export default SvgContactNofill;